<script setup>
/* global axios */
// Aba "Ligações (Wavoip)" das configurações do inbox: define o token de
// dispositivo Wavoip usado para ligações de WhatsApp nessa caixa.
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const route = useRoute();
const accountId = route.params.accountId;
const base = `/api/v1/accounts/${accountId}/kanban/wavoip_tokens`;

const token = ref('');
const saving = ref(false);

const load = async () => {
  try {
    const { data } = await axios.get(base, {
      params: { inbox_id: props.inbox.id },
    });
    token.value = data.data?.device_token || '';
  } catch (e) {
    token.value = '';
  }
};

const save = async () => {
  saving.value = true;
  try {
    await axios.post(base, {
      inbox_id: props.inbox.id,
      device_token: token.value.trim(),
    });
    useAlert(t('INBOX_MGMT.WAVOIP.SAVED'));
  } catch (e) {
    useAlert(e?.response?.data?.error || t('INBOX_MGMT.WAVOIP.ERROR'));
  } finally {
    saving.value = false;
  }
};

onMounted(load);
</script>

<template>
  <div class="p-6 mx-6">
    <h4 class="text-base font-medium text-n-slate-12">
      {{ t('INBOX_MGMT.WAVOIP.TITLE') }}
    </h4>
    <p class="mt-1 mb-4 text-sm text-n-slate-11">
      {{ t('INBOX_MGMT.WAVOIP.DESC') }}
    </p>
    <label class="block mb-1 text-sm font-medium text-n-slate-12">
      {{ t('INBOX_MGMT.WAVOIP.TOKEN_LABEL') }}
    </label>
    <input
      v-model="token"
      type="text"
      :placeholder="t('INBOX_MGMT.WAVOIP.TOKEN_PLACEHOLDER')"
      class="w-full max-w-lg px-3 py-2 text-sm border rounded-lg border-n-weak bg-n-alpha-1 text-n-slate-12"
    />
    <p class="mt-1 mb-4 text-xs text-n-slate-10">
      {{ t('INBOX_MGMT.WAVOIP.HINT') }}
    </p>
    <NextButton
      :label="t('INBOX_MGMT.WAVOIP.SAVE')"
      blue
      sm
      :is-loading="saving"
      @click="save"
    />
  </div>
</template>
